import { getOrderEditLimit } from '@/apis/common'

const state = {
  orderEditLimit: {
    allocationOrder: null,
    purchaseOrder: null,
    purchasePlanOrder: null,
    saleOrder: null,
    salePlanOrder: null,
    storePaymentOrder: null,
  },
}

const mutations = {
  SET_ORDER_EDIT_LIMIT(state, limit) {
    // 设置所有类型的订单编辑限制
    state.orderEditLimit = {
      allocationOrder: limit?.allocationOrder || null,
      purchaseOrder: limit?.purchaseOrder || null,
      purchasePlanOrder: limit?.purchasePlanOrder || null,
      saleOrder: limit?.saleOrder || null,
      salePlanOrder: limit?.salePlanOrder || null,
      storePaymentOrder: limit?.storePaymentOrder || null,
    }
  },
}

const actions = {
  async fetchOrderEditLimit({ commit }) {
    const response = await getOrderEditLimit()
    commit('SET_ORDER_EDIT_LIMIT', response)
    return response
  },
}

const getters = {
  // 获取所有类型的订单编辑限制
  orderEditLimit: (state) => state.orderEditLimit,
  // 获取特定类型的订单编辑限制
  getAllocationOrderLimit: (state) => state.orderEditLimit.allocationOrder,
  getPurchaseOrderLimit: (state) => state.orderEditLimit.purchaseOrder,
  getPurchasePlanOrderLimit: (state) => state.orderEditLimit.purchasePlanOrder,
  getSaleOrderLimit: (state) => state.orderEditLimit.saleOrder,
  getSalePlanOrderLimit: (state) => state.orderEditLimit.salePlanOrder,
  getStorePaymentOrderLimit: (state) => state.orderEditLimit.storePaymentOrder,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
